import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import PopinBanner from './PopinBanner';
import PopinCentered from './PopinCentered';
import PopinClassic from './PopinClassic';
import PopinEdging from './PopinEdging';
const Popins = ({ popins }) => {
    return (_jsx(_Fragment, { children: popins.map((popin, index) => {
            if (popin.format === 'banner') {
                return _jsx(PopinBanner, { popin: popin }, index);
            }
            if (popin.format === 'popin') {
                return _jsx(PopinClassic, { popin: popin }, index);
            }
            if (popin.format === 'centered') {
                return _jsx(PopinCentered, { popin: popin }, index);
            }
            if (popin.format === 'edging') {
                return _jsx(PopinEdging, { popin: popin }, index);
            }
            return null;
        }) }));
};
export default Popins;
